var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
var cls = classNames('x-axis');
export var XAxisDefaultProps = {
  divisions: 10,
  maxValue: 1000,
  formatTickValue: function formatTickValue(value, precision) {
    return value.toFixed(precision);
  },
  minValue: 0,
  markLength: 4,
  markWidth: 2,
  showTicks: true,
  showLine: true,
  showMarks: true,
  lineWidth: 2,
  lineColor: 'line',
  tickSpaceUnits: 1
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    font-family: ", ";\n    width: 100%;\n    height: 1.2em;\n    line-height: 1.2em;\n    position: relative;\n\n    \n  "], ["\n    font-size: ", ";\n    font-family: ", ";\n    width: 100%;\n    height: 1.2em;\n    line-height: 1.2em;\n    position: relative;\n\n    \n  "])), theme.FONT_SIZE(13), theme.FONT('sans'))
});
var LineStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var lineColor = _a.lineColor,
        lineWidth = _a.lineWidth;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      height: ", "px;\n      width: 100%;\n      position: absolute;\n      top: 0px;\n      background-color: ", ";\n      font-size: 0;\n    "], ["\n      height: ", "px;\n      width: 100%;\n      position: absolute;\n      top: 0px;\n      background-color: ", ";\n      font-size: 0;\n    "])), lineWidth, theme.COLOR(lineColor));
  })
});
var TickStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 0;\n    display: none;\n\n    &:last-of-type,\n    &:first-of-type {\n      display: flex;\n    }\n\n    ", "\n  "], ["\n    position: absolute;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 0;\n    display: none;\n\n    &:last-of-type,\n    &:first-of-type {\n      display: flex;\n    }\n\n    ", "\n  "])), function (_a) {
    var lineWidth = _a.lineWidth,
        spaceUnits = _a.spaceUnits;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      top: ", ";\n    "], ["\n      top: ", ";\n    "])), theme.UNIT(spaceUnits, lineWidth));
  }),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var MarkStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: 0;\n    align-self: flex-start;\n  \n    ", "\n\n  "], ["\n    font-size: 0;\n    align-self: flex-start;\n  \n    ", "\n\n  "])), function (_a) {
    var _color = _a._color,
        spaceUnits = _a.spaceUnits,
        _length = _a._length,
        _width = _a._width;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      width: ", "px;\n      margin-bottom: ", ";\n      background: ", ";\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      margin-bottom: ", ";\n      background: ", ";\n      height: ", "px;\n    "])), _width, theme.UNIT(spaceUnits), theme.COLOR(_color), _length);
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Line: styled.div.attrs(cls.attr('line'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LineStyles),
  Tick: styled.span.attrs(cls.attr('tick'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TickStyles),
  Mark: styled.span.attrs(cls.attr('mark'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), MarkStyles)
};
export var XAxis = function XAxis(props) {
  var className = props.className,
      divisions = props.divisions,
      maxValue = props.maxValue,
      showLine = props.showLine,
      lineColor = props.lineColor,
      lineWidth = props.lineWidth,
      showMarks = props.showMarks,
      tickSpaceUnits = props.tickSpaceUnits,
      markLength = props.markLength,
      markWidth = props.markWidth,
      showTicks = props.showTicks,
      formatTickValue = props.formatTickValue;

  var ticks = __spreadArray([], __read(Array(divisions + 1).keys()), false);

  var stepBy = maxValue / divisions;
  return React.createElement(My.Container, {
    showLine: showLine,
    lineWidth: lineWidth,
    lineColor: lineColor,
    className: cls.name(className)
  }, showLine && React.createElement(My.Line, {
    className: cls.sub('line'),
    spaceUnits: showMarks ? 0 : tickSpaceUnits,
    lineColor: lineColor,
    lineWidth: lineWidth
  }), showTicks && ticks.map(function (tick) {
    var percentage = 100 * (tick / divisions);
    var precision = tick * stepBy % 1 === 0 ? 0 : 1;
    var tickValue = formatTickValue(tick * stepBy, precision);
    return React.createElement(My.Tick, {
      className: cls.sub('tick'),
      spaceUnits: showMarks ? 0 : tickSpaceUnits,
      lineWidth: lineWidth,
      style: {
        left: "calc(" + percentage.toFixed(2) + "% - " + tick * ((markWidth / 2 + 1) / divisions) + "px)"
      },
      key: tick
    }, showMarks && React.createElement(My.Mark, {
      className: cls.sub('mark'),
      _length: markLength,
      _width: markWidth,
      spaceUnits: tickSpaceUnits,
      _color: lineColor
    }), tick === divisions ? formatTickValue(maxValue, precision) : tickValue);
  }));
};
XAxis.defaultProps = XAxisDefaultProps;
XAxis.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;